import { journalsQueries } from "@entities/journal";
import { PartType, SectionType } from "./types";

export const mapPartToPathSegment = (part?: PartType): string => {
  switch (part) {
    case "senders":
      return "sender";
    case "approvers":
      return "approver";
    case "inputters":
      return "inputter";
    case "signers":
      return "signer";
    default:
      return "sender";
  }
};

export const generatePartName = (part?: PartType): string => {
  switch (part) {
    case "senders":
      return "Отправка в ГСН";
    case "approvers":
      return "Проверка данных";
    case "inputters":
      return "Заполнение данных";
    case "signers":
      return "Подписание";
    default:
      return "Без названия";
  }
};

export const generateTitleName = (section: SectionType): string => {
  switch (section) {
    case "title":
      return "Титульный лист";
    case "section-one":
      return "Раздел 1";
    case "section-two":
      return "Раздел 2";
    case "section-three":
      return "Раздел 3";
    case "section-four":
      return "Раздел 4";
    case "section-five":
      return "Раздел 5";
    case "section-six":
      return "Раздел 6";
    default:
      return "Без названия";
  }
};

export const getSignersQuery = ({
  titleId = "",
  sectionOneId = "",
  sectionTwoId = "",
  sectionThreeId = "",
  sectionFourId = "",
  sectionSixId = "",
  type,
}: {
  titleId?: string;
  sectionOneId?: string;
  sectionTwoId?: string;
  sectionThreeId?: string;
  sectionFourId?: string;
  sectionSixId?: string;
  type: SectionType;
}) => {
  switch (type) {
    case "title":
      return journalsQueries.getJournalSignersList(titleId);
    case "section-one":
      return journalsQueries.getSectionOneSignersList(sectionOneId);
    case "section-two":
      return journalsQueries.getSectionTwoSignersList(sectionTwoId);
    case "section-three":
      return journalsQueries.getSectionThreeSignersList(sectionThreeId);
    case "section-four":
      return journalsQueries.getSectionFourSignersList(sectionFourId);
    case "section-six":
      return journalsQueries.getSectionSixSignersList(sectionSixId);
    default:
      return journalsQueries.getJournalSignersList(titleId);
  }
};

export const getResponsibleQuery = (section: SectionType, id: string) => {
  switch (section) {
    case "title":
      return journalsQueries.getOriginalResponsibleList(id);
    case "section-one":
      return journalsQueries.getResponsibleSectionOneList(id);
    case "section-two":
      return journalsQueries.getResponsibleSectionTwoList(id);
    case "section-three":
      return journalsQueries.getResponsibleSectionThreeList(id);
    case "section-four":
      return journalsQueries.getResponsibleSectionFourList(id);
    case "section-six":
      return journalsQueries.getResponsibleSectionSixList(id);
    default:
      return journalsQueries.getResponsibleList(id);
  }
};

export const getTextColor = (user: any): string => {
  if (
    user.userHistory?.isBlock === true ||
    user.userHistory?.roleInfo?.isCurrently === false
  ) {
    return "#333333";
  }
  return "black";
};

export const TABLE_COLUMNS = [
  { title: "ФИО", span: 5 },
  { title: "Организация", span: 5 },
  { title: "Должность", span: 5 },
  { title: "Email", span: 5 },
  { title: "Телефон", span: 4 },
] as const;
